import { render, staticRenderFns } from "./proposal-preview-pricing-option.vue?vue&type=template&id=86cf96a2"
import script from "./proposal-preview-pricing-option.vue?vue&type=script&lang=js"
export * from "./proposal-preview-pricing-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports